// extracted by mini-css-extract-plugin
export default {"page-loading":"sign-up-via-company-magic-link_page-loading__0XlIt"};